let data = {};
let mode = 3;
let Base = '';
switch (mode) {
    case 1: Base = 'http://localhost'; break;
    case 2: Base = 'https://php7.teamlimonbyte.com/Sysge24/api/public'; break;
    case 3: Base = 'https://api.sysge24.com'; break;
    case 4: Base = 'https://tuqueque.braxo.io/api/public'; break;
    default: break;
}
let googleMapsKey = mode === 1
    ? 'AIzaSyCgCE_R0oRJ6ZgycjzZTKFNKZJPMZyaIPs' // dev local
    : 'AIzaSyDjTVeKdAsDBR-Lb5e8ifJWx6ONpffUe30'; // Tuqueque / SYSGE PROD

switch (mode) {
    case 1: // dev local
        data = {
            BaseURI: `${Base}:8000/api/`,
            BasePublic: `${Base}:8000/`,
            BaseStorage: `${Base}:8000/storage/`,
            BaseStore: 'http://localhost:3000/Sysge24/public/',
            Socket: `${Base}:11020`,
            mode: mode,
            googleMapsKey: googleMapsKey,
        }
        break;
    case 2: //RHINELLA
        data = {
            BaseURI: `${Base}/api/`,
            BasePublic: `${Base}/`,
            BaseStorage: `${Base}/storage/`,
            BaseStore: 'http://php7.teamlimonbyte.com/Sysge24/public/',
            Socket: `https://php7.teamlimonbyte.com:11021`,
            mode: mode,
            googleMapsKey: googleMapsKey,
        }
        break;
    case 3: //SYSGE PROD
        data = {
            BaseURI: `${Base}/api/`,
            BasePublic: `${Base}/`,
            BaseStorage: `${Base}/storage/`,
            BaseStore: 'https://app.sysge24.com/',
            Socket: `https://web.braxo.io:11021`,
            mode: mode,
            googleMapsKey: googleMapsKey,
        }
        break;
    case 4: //TUQUEQUE
        data = {
            BaseURI: `${Base}/api/`,
            BasePublic: `${Base}/`,
            BaseStorage: `${Base}/storage/`,
            BaseStore: 'https://tuqueque.braxo.io/api/public/',
            Socket: `https://tuqueque.braxo.io:11021`,
            mode: mode,
        }
        break;
    default:
        break;
}
export default data;